/* 🤖 this file was generated by svg-to-ts */
export const IconBigBrandFacebook: {
    name: 'big-brand-facebook';
    data: string;
} = {
    name: 'big-brand-facebook',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path fill-rule="evenodd" d="M109.68 7.91H17.12a10 10 0 0 0-10 10v92.56a10 10 0 0 0 10 10h92.56a10 10 0 0 0 10-10V17.91a10 10 0 0 0-10-10m-27.1 28.94a1 1 0 0 1-1 1h-8A3.56 3.56 0 0 0 70 41.42v8.41h11.4a1 1 0 0 1 1 1.09l-1 11.84a1 1 0 0 1-1 .92H70V103a1 1 0 0 1-1 1H54.61a1 1 0 0 1-1-1V63.68h-7.19a1 1 0 0 1-1-1V50.83a1 1 0 0 1 1-1h7.19V38.41A14.41 14.41 0 0 1 68 24h13.58a1 1 0 0 1 1 1z"/></svg>`,
};
